// src/components/Nav.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import SearchHeader from './SearchHeader';

function NavigationComponent() {
  const navigate = useNavigate();
  const { logout } = useAuth();

  return (
    <nav 
      className="py-3 px-6 shadow-lg bg-white"
    >
      <div className="flex justify-between items-center">
        {/* Left side - Logo + Wordmark */}
        <div className="flex items-center space-x-3">
          <a 
            href="/dashboard" 
            className="text-decoration-none flex items-center"
            onClick={(e) => {
              e.preventDefault();
              navigate('/dashboard');
            }}
          >
            <img
              src="/assets/logo no background.png"
              alt="Printereum Logo"
              style={{ height: 100 }}
            />
            <img
              src="/assets/company name 2.png"
              alt="Printereum"
              style={{ height: 100, marginLeft: 12 }}
            />
          </a>
        </div>

        {/* Right side - SearchHeader */}
        <div className="flex items-center">
          <SearchHeader 
            variant="navbar" 
            position="navigation"
            className="text-black"
          />
        </div>
      </div>
    </nav>
  );
}

export default NavigationComponent;